import * as actions from './actionCreators';
import request from '../../utils/request_ajax';

function requestCurrentPageContentsAndDispatchSuccessAction(dispatch) {
  dispatch(actions.requestJourneyContents());
  request
    .get(window.location.pathname + window.location.search)
    .then(payload => {
      dispatch(actions.requestJourneyContentsSuccess(payload));
    });
}

export function requestJourneyContents() {
  return requestCurrentPageContentsAndDispatchSuccessAction;
}
